export default "__VITE_ASSET__CenQqQNQ__"